/**
 * by-react-utils v0.0.18
 * (c) 2017 Alex Toudic
 * Released under MIT License.
 **/

import React, { Children, Component, cloneElement } from 'react';
import bodymovin from 'bodymovin';
import { append, children, clearStyle, createElement, forEach, forIn, getAttr, on, setStyleProp } from 'chirashi';
import { reduce, uniqueId } from 'lodash';
import { findDOMNode } from 'react-dom';

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var BodyMovin = function (_Component) {
  inherits(BodyMovin, _Component);

  function BodyMovin() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BodyMovin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BodyMovin.__proto__ || Object.getPrototypeOf(BodyMovin)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseEnter = function () {
      _this.tryToPlay();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(BodyMovin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.anim = bodymovin.loadAnimation(_extends({}, this.props, {
        container: this.node
      }));

      this.anim.addEventListener('complete', function () {
        return _this2.isPlaying = false;
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var play = _ref2.play;

      if (play && !this.props.play) this.tryToPlay();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.anim.destroy();
    }
  }, {
    key: 'tryToPlay',
    value: function tryToPlay() {
      if (!this.isPlaying) {
        this.isPlaying = true;
        this.anim.goToAndPlay(0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return React.createElement('span', {
        className: this.props.className,
        onMouseEnter: this.handleMouseEnter,
        ref: function ref(node) {
          return _this3.node = node;
        }
      });
    }
  }]);
  return BodyMovin;
}(Component);

BodyMovin.defaultProps = {
  loop: false,
  autoplay: false,
  playOnOver: true,
  play: false
};

var Icon = (function (_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      name = _ref.name;
  return React.createElement(
    'svg',
    { className: name + '-icon ' + className },
    React.createElement('use', { xlinkHref: '#' + name })
  );
});

var IconsSprite = (function (_ref) {
  var children$$1 = _ref.children;
  return React.createElement(
    'svg',
    { style: { display: 'none' } },
    React.createElement(
      'defs',
      null,
      Children.map(children$$1, function (icon) {
        var name = icon.props.name;


        return React.createElement(
          'g',
          {
            key: name,
            id: name
          },
          icon
        );
      })
    )
  );
});

var SvgFromFile = function (_Component) {
  inherits(SvgFromFile, _Component);
  createClass(SvgFromFile, null, [{
    key: 'fetchElement',
    value: function fetchElement(path) {
      return fetch(path).then(function (data) {
        return data.text();
      }).then(function (text) {
        return text.slice(text.indexOf('<svg'));
      });
    }
  }]);

  function SvgFromFile(props) {
    var _ref,
        _this2 = this;

    classCallCheck(this, SvgFromFile);

    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    var _this = possibleConstructorReturn(this, (_ref = SvgFromFile.__proto__ || Object.getPrototypeOf(SvgFromFile)).call.apply(_ref, [this, props].concat(rest)));

    _this.state = {
      svgElement: ''
    };


    if (props.path) {
      asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _this;
                _context.next = 3;
                return SvgFromFile.fetchElement(props.path);

              case 3:
                _context.t1 = _context.sent;

                _context.t0.applySvg.call(_context.t0, _context.t1);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    } else {
      _this.applySvg(props.file);
    }
    return _this;
  }

  createClass(SvgFromFile, [{
    key: 'applySvg',
    value: function applySvg(content) {
      var svgElement = createElement();
      this.setState({ svgElement: svgElement });
      append(this.node, children(svgElement));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.state.svgElement) return null;

      var _getAttr = getAttr(this.state.svgElement, 'viewBox', 'width', 'height'),
          viewBox = _getAttr.viewBox,
          width = _getAttr.width,
          height = _getAttr.height;

      return React.createElement('svg', {
        id: this.props.name,
        viewBox: viewBox || '0 0 ' + width + ' ' + height,
        ref: function ref(node) {
          return _this3.node = node;
        }
      });
    }
  }]);
  return SvgFromFile;
}(Component);

var ScrollBlocker = function (_Component) {
  inherits(ScrollBlocker, _Component);

  function ScrollBlocker() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollBlocker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollBlocker.__proto__ || Object.getPrototypeOf(ScrollBlocker)).call.apply(_ref, [this].concat(args))), _this), _this.scrollId = uniqueId('scroll-'), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollBlocker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      ScrollBlocker.toggleEnabled(this.scrollId, this.props.enabled);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var enabled = _ref2.enabled;

      if (enabled === this.props.enabled) return;

      ScrollBlocker.toggleEnabled(this.scrollId, enabled);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      ScrollBlocker.toggleEnabled(this.scrollId, true);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }], [{
    key: 'toggleEnabled',
    value: function toggleEnabled(scrollId, enabled) {
      if (enabled) {
        ScrollBlocker.retainers.splice(ScrollBlocker.retainers.indexOf(scrollId), 1);
      } else {
        ScrollBlocker.retainers.push(scrollId);
      }

      var previous = ScrollBlocker.blocked;
      ScrollBlocker.blocked = Boolean(ScrollBlocker.retainers.length);

      if (previous !== ScrollBlocker.blocked) {
        if (ScrollBlocker.blocked) {
          setStyleProp(document.documentElement, { overflow: 'hidden' });
        } else {
          clearStyle(document.documentElement, 'overflow');
        }
      }
    }
  }]);
  return ScrollBlocker;
}(Component);

ScrollBlocker.blocked = false;
ScrollBlocker.retainers = [];
ScrollBlocker.defaultProps = {
  enabled: false
};

var Transition = function (_Component) {
  inherits(Transition, _Component);

  function Transition() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Transition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Transition.__proto__ || Object.getPrototypeOf(Transition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: true,
      enter: false,
      leave: false
    }, _this.toggleState = function () {
      _this.setState({
        show: _this.props.show,
        active: false
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Transition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.toggleAnim(this.props);

      this.unbind = on(findDOMNode(this.node), {
        transitionend: this.toggleState
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.show !== nextProps.show) {
        this.toggleAnim(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbind();
    }
  }, {
    key: 'toggleAnim',
    value: function toggleAnim(_ref2) {
      var _this2 = this;

      var show = _ref2.show,
          delay = _ref2.delay;

      this.setState({
        enter: show,
        leave: !show
      });

      setTimeout(function () {
        _this2.setState({
          active: true
        });
      }, delay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var anim = this.props.anim;
      var _state = this.state,
          enter = _state.enter,
          leave = _state.leave,
          active = _state.active;


      var className = '' + anim + (enter ? '--enter' : leave ? '--leave' : '');

      return this.state.show ? cloneElement(Children.only(this.props.children), {
        ref: function ref(node) {
          return _this3.node = node;
        },
        className: anim + ' ' + className + ' ' + (active ? className + '-active' : '')
      }) : null;
    }
  }]);
  return Transition;
}(Component);

Transition.defaultProps = {
  show: true,
  delay: 0
};

/* eslint-disable */

var BreakpointListener = function () {
    function BreakpointListener(breakpoints) {
        var _this = this;

        classCallCheck(this, BreakpointListener);

        this.resize = function () {
            var width = window.innerWidth,
                i = _this._breakpoints.length;

            while (i-- && width >= _this._breakpoints[i].size) {}

            _this.current = _this._breakpoints[Math.min(_this._breakpoints.length - 1, i + 1)].label;
        };

        this._current = '';
        this._listeners = [];
        this._breakpoints = [];

        forIn(breakpoints, function (key, value) {
            _this._breakpoints.push({
                size: parseInt(value),
                label: key
            });
        });

        this._breakpoints.sort(function (a, b) {
            return b.size - a.size;
        });

        this.offResize = on(window, { resize: this.resize });

        this.resize({
            width: window.innerWidth
        });
    }

    createClass(BreakpointListener, [{
        key: 'trigger',
        value: function trigger() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var listener = _step.value;

                    listener(this._current);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'on',
        value: function on$$1(callback) {
            this._listeners.push(callback);
        }
    }, {
        key: 'off',
        value: function off(callback) {
            this._listeners.splice(this._listeners.indexOf(callback), 1);
        }
    }, {
        key: 'kill',
        value: function kill() {
            this.offResize();
        }
    }, {
        key: 'current',
        set: function set$$1(value) {
            if (this._current == value) return;

            this._current = value;

            this.trigger();
        },
        get: function get$$1() {
            return this._current;
        }
    }]);
    return BreakpointListener;
}();

/* eslint-disable */

var BreakpointManager = function (_BreakpointListener) {
    inherits(BreakpointManager, _BreakpointListener);

    function BreakpointManager(breakpoints) {
        classCallCheck(this, BreakpointManager);

        var _this = possibleConstructorReturn(this, (BreakpointManager.__proto__ || Object.getPrototypeOf(BreakpointManager)).call(this, breakpoints));

        _this.bindGroupBehaviors = function (group) {
            var behaviors = void 0;
            if (!(behaviors = _this._groups[group])) return;

            var disabled = [],
                enabled = [];

            var i = behaviors.enabled.length;
            while (i--) {
                var behavior = behaviors.enabled[i];

                if (behavior.sizes.indexOf(_this.current) == -1) {
                    behavior.disable(_this.current);
                    disabled.push(behavior);
                } else enabled.push(behavior);
            }

            var j = behaviors.disabled.length;
            while (j--) {
                var _behavior = behaviors.disabled[j];

                if (_behavior.sizes.indexOf(_this.current) != -1 && _behavior.and()) {
                    _behavior.enable(_this.current);
                    enabled.push(_behavior);
                } else disabled.push(_behavior);
            }

            behaviors.disabled = disabled;
            behaviors.enabled = enabled;

            _this._groups[group] = behaviors;
        };

        _this._groups = {};
        return _this;
    }

    createClass(BreakpointManager, [{
        key: 'trigger',
        value: function trigger() {
            this.bindBehaviors();
            get(BreakpointManager.prototype.__proto__ || Object.getPrototypeOf(BreakpointManager.prototype), 'trigger', this).call(this);
        }
    }, {
        key: 'bindBehaviors',
        value: function bindBehaviors() {
            if (this._groups) {
                forIn(this._groups, this.bindGroupBehaviors);
            }
        }
    }, {
        key: 'refreshGroupBehaviors',
        value: function refreshGroupBehaviors(group) {
            this.disableGroupBehaviors(group);
            this.bindGroupBehaviors(group);
        }
    }, {
        key: 'addToGroup',
        value: function addToGroup(group, behaviors) {
            var bind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var behaviorsGroup = this._groups[group];

            if (!behaviorsGroup) {
                behaviorsGroup = {
                    disabled: [],
                    enabled: []
                };
            }

            var i = behaviors.length;
            while (i--) {
                var behavior = behaviors[i];

                if (!behavior.disable) behavior.disable = function () {};
                if (!behavior.enable) behavior.enable = function () {};
                if (!behavior.and) behavior.and = function () {
                    return true;
                };

                if (bind && behavior.sizes.indexOf(this.current) != -1 && behavior.and()) {
                    behavior.enable(this.current);
                    behaviorsGroup.enabled.push(behavior);
                } else {
                    behaviorsGroup.disabled.push(behavior);
                }
            }

            this._groups[group] = behaviorsGroup;
        }
    }, {
        key: 'removeGroup',
        value: function removeGroup(group) {
            var _this2 = this;

            if (!this._groups[group]) return;

            forEach(this._groups[group].enabled, function (behavior) {
                return behavior.disable(_this2.current);
            });

            delete this._groups[group];
        }
    }, {
        key: 'disableGroupBehaviors',
        value: function disableGroupBehaviors(group) {
            if (!this._groups[group]) return;

            var behaviors = this._groups[group];

            var i = behaviors.enabled.length;
            while (i--) {
                var behavior = behaviors.enabled[i];

                behavior.disable(this.current);
            }

            behaviors.disabled = behaviors.disabled.concat(behaviors.enabled);
            behaviors.enabled = [];
        }
    }, {
        key: 'kill',
        value: function kill() {
            var _this3 = this;

            forIn(this._groups, function (group, behaviors) {
                forEach(behaviors.enabled, function (behavior) {
                    return behavior.disable(_this3.current);
                });
            });

            get(BreakpointManager.prototype.__proto__ || Object.getPrototypeOf(BreakpointManager.prototype), 'kill', this).call(this);
        }
    }]);
    return BreakpointManager;
}(BreakpointListener);

var defaultBreakpoints = {
  huge: '1440px',
  large: '1170px',
  medium: '768px',
  small: '450px'
};

var _manager = { value: null };
var _breakpoints = { value: defaultBreakpoints };

var configBreakpoints = function configBreakpoints(breakpoints) {
  _breakpoints.value = breakpoints;
};

var withBehavior = function withBehavior(options) {
  return function (ComposedComponent) {
    return function (_Component) {
      inherits(EnhancedComponent, _Component);

      function EnhancedComponent() {
        var _ref;

        classCallCheck(this, EnhancedComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = possibleConstructorReturn(this, (_ref = EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).call.apply(_ref, [this].concat(toConsumableArray(args))));

        _this.state = {};


        if (!_manager.value) {
          _manager.value = new BreakpointManager(_breakpoints.value);
        }

        _this.behaviorId = uniqueId('behavior_');

        forEach(options, function (behavior) {
          _manager.value.addToGroup(_this.behaviorId, [{
            sizes: behavior.sizes,
            enable: function enable() {
              if (behavior.enable) _this.setState(behavior.enable());
            },
            disable: function disable() {
              if (behavior.disable) _this.setState(behavior.disable());
            }
          }], false);
        });
        return _this;
      }

      createClass(EnhancedComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          _manager.value.bindGroupBehaviors(this.behaviorId);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          _manager.value.removeGroup(this.behaviorId);
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          return React.createElement(ComposedComponent, _extends({
            ref: function ref(context) {
              return _this2.context = context;
            }
          }, this.state, this.props));
        }
      }]);
      return EnhancedComponent;
    }(Component);
  };
};

var index = Object.assign(withBehavior, { configBreakpoints: configBreakpoints });

var withComputed = (function (mapPropsToHandler) {
  return function (WrappedComponent) {
    return function (_Component) {
      inherits(WithPropsWatch, _Component);

      function WithPropsWatch() {
        classCallCheck(this, WithPropsWatch);
        return possibleConstructorReturn(this, (WithPropsWatch.__proto__ || Object.getPrototypeOf(WithPropsWatch)).apply(this, arguments));
      }

      createClass(WithPropsWatch, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this.computeState(function (state, handler, propName) {
            return _extends({}, state, handler(_this2.props, null));
          });
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          var _this3 = this;

          this.computeState(function (state, handler, propName) {
            return nextProps[propName] === _this3.props[propName] ? state : _extends({}, state, handler(nextProps, _this3.props));
          });
        }
      }, {
        key: 'computeState',
        value: function computeState(iteratee) {
          this.setState(reduce(mapPropsToHandler, iteratee, {}));
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(WrappedComponent, _extends({}, this.props, this.state));
        }
      }]);
      return WithPropsWatch;
    }(Component);
  };
});

var withResize = (function (callback) {
  return function (WrappedComponent) {
    return function (_Component) {
      inherits(WithResize, _Component);

      function WithResize() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, WithResize);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = WithResize.__proto__ || Object.getPrototypeOf(WithResize)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.resize = function () {
          _this.setState(callback(findDOMNode(_this.el)));
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      createClass(WithResize, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.unbind = on(window, { resize: this.resize });
          this.resizeTimeout = setTimeout(this.resize, 100);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.unbind();
          clearTimeout(this.resizeTimeout);
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          return React.createElement(WrappedComponent, _extends({
            ref: function ref(el) {
              return _this2.el = el;
            }
          }, this.props, this.state));
        }
      }]);
      return WithResize;
    }(Component);
  };
});

var withVisibility = (function (WrappedComponent) {
  return function (_Component) {
    inherits(WithVisibility, _Component);

    function WithVisibility() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, WithVisibility);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = WithVisibility.__proto__ || Object.getPrototypeOf(WithVisibility)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        visibility: document.visibilityState
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(WithVisibility, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.unbind = on(document, {
          visibilitychange: function visibilitychange() {
            _this2.setState({ visibility: document.visibilityState });
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unbind();
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(WrappedComponent, _extends({}, this.props, this.state));
      }
    }]);
    return WithVisibility;
  }(Component);
});

var createReducer = (function (initialState, handlers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    return action.type in handlers ? handlers[action.type](state, action) : state;
  };
});

export { BodyMovin, Icon, IconsSprite, SvgFromFile, ScrollBlocker, Transition, index as withBehavior, withComputed, withResize, withVisibility, createReducer };



//////////////////
// WEBPACK FOOTER
// ./node_modules/by-react-utils/dist/by-react-utils.mjs
// module id = 59
// module chunks = 0